import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableSymptomFragment = { readonly __typename?: 'SyncableSymptom', readonly id: string, readonly name: string, readonly externalCoding?: { readonly __typename?: 'ExternalCoding', readonly icd10?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly icd11?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly snomed?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null } | null, readonly i18n: ReadonlyArray<{ readonly __typename?: 'SymptomI18NSchema', readonly locale: Types.L10N, readonly displayName: string }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncSymptomPullQueryVariables = Types.Exact<{
  input: Types.PullSymptomInput;
}>;


export type SyncSymptomPullQuery = { readonly __typename?: 'Query', readonly pullSymptom: { readonly __typename?: 'PullSymptomResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableSymptom', readonly id: string, readonly name: string, readonly externalCoding?: { readonly __typename?: 'ExternalCoding', readonly icd10?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly icd11?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly snomed?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'ExternalCodingReference', readonly code: string, readonly system?: string | null } | null } | null, readonly i18n: ReadonlyArray<{ readonly __typename?: 'SymptomI18NSchema', readonly locale: Types.L10N, readonly displayName: string }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableSymptomFragmentDoc = gql`
    fragment WholeSyncableSymptom on SyncableSymptom {
  id
  name
  externalCoding {
    icd10 {
      code
      system
    }
    icd11 {
      code
      system
    }
    snomed {
      code
      system
    }
    loinc {
      code
      system
    }
  }
  i18n {
    locale
    displayName
  }
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncSymptomPullDocument = gql`
    query SyncSymptomPull($input: PullSymptomInput!) {
  pullSymptom(input: $input) {
    documents {
      ...WholeSyncableSymptom
    }
  }
}
    ${WholeSyncableSymptomFragmentDoc}`;

/**
 * __useSyncSymptomPullQuery__
 *
 * To run a query within a React component, call `useSyncSymptomPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncSymptomPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncSymptomPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncSymptomPullQuery(baseOptions: Apollo.QueryHookOptions<SyncSymptomPullQuery, SyncSymptomPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncSymptomPullQuery, SyncSymptomPullQueryVariables>(SyncSymptomPullDocument, options);
      }
export function useSyncSymptomPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncSymptomPullQuery, SyncSymptomPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncSymptomPullQuery, SyncSymptomPullQueryVariables>(SyncSymptomPullDocument, options);
        }
export type SyncSymptomPullQueryHookResult = ReturnType<typeof useSyncSymptomPullQuery>;
export type SyncSymptomPullLazyQueryHookResult = ReturnType<typeof useSyncSymptomPullLazyQuery>;
export type SyncSymptomPullQueryResult = Apollo.QueryResult<SyncSymptomPullQuery, SyncSymptomPullQueryVariables>;